module.exports = __webpack_public_path__ + "img/login_light.85569424.svg";